package ro.horatiu_udrea.resursedeblocat

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.lifecycle.ViewModel

class TrackQuestionnaireViewModel(
    private val userId: String,
    month: Int,
    year: Int,
    initialTracking: MonthlyTracking? = null
) : ViewModel() {
    var tracking by mutableStateOf(initialTracking ?: MonthlyTracking(month = month, year = year))
        private set

    var currentStep by mutableStateOf(0)
        private set

    var isLoading by mutableStateOf(false)
        private set

    var errorMessage by mutableStateOf<String?>(null)
        private set

    fun setAnswer(questionId: String, answer: Any) {
        val updatedAnswers = tracking.answers.toMutableMap()
        updatedAnswers[questionId] = answer
        tracking = tracking.copy(answers = updatedAnswers)
        save() // Save progress
    }

    fun ensureDefaultAnswer(questionId: String, defaultValue: Any) {
        if (!tracking.answers.containsKey(questionId)) {
            setAnswer(questionId, defaultValue)
        }
    }

    fun nextStep(onFinished: () -> Unit) {
        if (currentStep < trackingSteps - 1) {
            val participated = tracking.answers[participatedMinigroupKey] as? Boolean ?: false
            if (currentStep == 8 && !participated) {
                currentStep += 2
            } else {
                currentStep++
            }
        } else {
            complete(onFinished)
        }
    }

    fun previousStep() {
        if (currentStep > 0) {
            val participated = tracking.answers[participatedMinigroupKey] as? Boolean ?: false
            if (currentStep == 10 && !participated) {
                currentStep -= 2
            } else {
                currentStep--
            }
        }
    }

    private fun save() {
        if (tracking.month == 0 || tracking.year == 0) return // Don't save if invalid month/year
        saveTracking(userId, tracking, { id ->
            tracking = tracking.copy(id = id)
        }, { error ->
            errorMessage = error
        })
    }

    private fun complete(onFinished: () -> Unit) {
        if (tracking.month == 0 || tracking.year == 0) return // Don't complete if invalid month/year
        isLoading = true
        val finalTracking = tracking.copy(completed = true)
        saveTracking(userId, finalTracking, { id ->
            tracking = finalTracking.copy(id = id)
            isLoading = false
            onFinished()
        }, { error ->
            errorMessage = error
            isLoading = false
        })
    }
}
